export default "__VITE_ASSET__CCm6X_ka__"